import { prefix } from "../../design-tokens/meta";
import { matchers } from "../../js/validate-props";
import { events } from "../../js/state-machine";

export const componentName = "Pagination";

export const defaultProps = Object.freeze({
    currentPage: 1,
    totalItems: 0,
    ariaCurrentPageDescription: "Navigate to page from 1 to {totalPages}",
});

export const schema = Object.freeze({
    currentPage: matchers.number,
    totalItems: matchers.number,
    ariaCurrentPageDescription: matchers.string,
});

export const eventMap = Object.freeze({
    firstPageClicked: events.firstPageClicked(componentName),
    lastPageClicked: events.lastPageClicked(componentName),
    nextPageClicked: events.nextPageClicked(componentName),
    previousPageClicked: events.previousPageClicked(componentName),
    pageChanged: events.pageChanged(componentName),
    pageSizeChanged: events.pageSizeChanged(componentName),
});

export const componentClasses = Object.freeze({
    pagination: {
        base: `${prefix}pagination`,
        width1024: `${prefix}pagination--width-1024`,
        width768: `${prefix}pagination--width-768`,
        width640: `${prefix}pagination--width-640`,
        width480: `${prefix}pagination--width-480`,
        width360: `${prefix}pagination--width-360`,
    },
    summary: `${prefix}pagination__summary`,
    perPageLabel: `${prefix}pagination__per-page-label`,
    perPageSelect: `${prefix}pagination__per-page-select`,
    range: `${prefix}pagination__range`,
    rangeStart: `${prefix}pagination__range-start`,
    rangeEnd: `${prefix}pagination__range-end`,
    rangeTotal: `${prefix}pagination__range-total`,
    rangeTotalLabel: `${prefix}pagination__range-total-label`,
    nav: `${prefix}pagination__nav`,
    firstPage: `${prefix}pagination__first-page`,
    prevPage: `${prefix}pagination__prev-page`,
    prevPageLabel: `${prefix}pagination__prev-page-label`,
    pageRange: `${prefix}pagination__page-range`,
    pageRangeLabel: `${prefix}pagination__page-range-label`,
    pageRangeCurrentWrapper: `${prefix}pagination__page-range-current-wrapper`,
    pageRangeCurrent: `${prefix}pagination__page-range-current`,
    pageRangeTotalLabel: `${prefix}pagination__page-range-total-label`,
    pageRangeTotal: `${prefix}pagination__page-range-total`,
    nextPage: `${prefix}pagination__next-page`,
    nextPageLabel: `${prefix}pagination__next-page-label`,
    lastPage: `${prefix}pagination__last-page`,
});

export const views = Object.freeze({
    pagination: {
        rest: {
            classList: [
                `!${componentClasses.pagination.width1024}`,
                `!${componentClasses.pagination.width768}`,
                `!${componentClasses.pagination.width640}`,
                `!${componentClasses.pagination.width480}`,
                `!${componentClasses.pagination.width360}`,
            ],
        },
        width1024: {
            classList: [
                componentClasses.pagination.width1024,
                `!${componentClasses.pagination.width768}`,
                `!${componentClasses.pagination.width640}`,
                `!${componentClasses.pagination.width480}`,
                `!${componentClasses.pagination.width360}`,
            ],
        },
        width768: {
            classList: [
                `!${componentClasses.pagination.width1024}`,
                componentClasses.pagination.width768,
                `!${componentClasses.pagination.width640}`,
                `!${componentClasses.pagination.width480}`,
                `!${componentClasses.pagination.width360}`,
            ],
        },
        width640: {
            classList: [
                `!${componentClasses.pagination.width1024}`,
                `!${componentClasses.pagination.width768}`,
                componentClasses.pagination.width640,
                `!${componentClasses.pagination.width480}`,
                `!${componentClasses.pagination.width360}`,
            ],
        },
        width480: {
            classList: [
                `!${componentClasses.pagination.width1024}`,
                `!${componentClasses.pagination.width768}`,
                `!${componentClasses.pagination.width640}`,
                componentClasses.pagination.width480,
                `!${componentClasses.pagination.width360}`,
            ],
        },
        width360: {
            classList: [
                `!${componentClasses.pagination.width1024}`,
                `!${componentClasses.pagination.width768}`,
                `!${componentClasses.pagination.width640}`,
                `!${componentClasses.pagination.width480}`,
                componentClasses.pagination.width360,
            ],
        },
    },
    summary: {
        itemsRange: {
            rest: { attrs: { "aria-hidden": null } },
            hidden: { attrs: { "aria-hidden": "true" } },
        },
    },
    nav: {
        rest: { attrs: { "aria-disabled": null } },
        inactive: { attrs: { "aria-disabled": "true" } },
    },
});

// Pagination don't work with screen breakpoints
// Those width values are related directly to the pagination width
// Due to specificity using numbers as keys make it more flexible
// and with a good scaling in case a new number need to be added in middle
export const width = {
    1024: 1024,
    768: 768,
    640: 640,
    480: 480,
    360: 360,
};
